import { loadEnv as load } from './shims/load-env';
export function loadEnv(): Record<string, string | undefined> {
  try {
    const env = load?.();
    return typeof env === 'object' && env != null ? env : {};
  } catch {
    return {};
  }
}

/**
 * Global configuration for logging.
 */
export const logging = {
  get dontLogModelData() {
    return isEnabled('AGENTS_DONT_LOG_MODEL_DATA');
  },
  get dontLogToolData() {
    return isEnabled('AGENTS_DONT_LOG_TOOL_DATA');
  },
};

/**
 * Checks if a flag is enabled in the environment.
 *
 * @param flagName - The name of the flag to check.
 * @returns `true` if the flag is enabled, `false` otherwise.
 */
function isEnabled(flagName: string): boolean {
  const env = loadEnv();
  return (
    typeof env !== 'undefined' &&
    (env[flagName] === 'true' || env[flagName] === '1')
  );
}

export const tracing = {
  get disabled() {
    if (loadEnv().NODE_ENV === 'test') {
      // disabling by default in tests
      return true;
    }
    return isEnabled('LYRA_DISABLE_TRACING');
  },
};
